import {
    GET_TOTAL_REPORTS,
    SET_DATE_FROM,
    SET_DATE_TO,
    GET_USERNAMES,
    SET_UID,
    SET_WORKSHEET_STATUS,
    FILTER_WORKSHEET_STATUS,
    GET_REPORT_TITLES,
    SET_REPORT_TYPE,
    GET_JOBPACKS,
    SET_JOB_ID,
    SET_SELECTED_ROW
} from "./types";
import firebase from "firebase/app";

export const getTotalUserReports = () => {
    return dispatch => {
        dispatch({ type: GET_TOTAL_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_TOTAL_REPORTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/reports")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_TOTAL_REPORTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOTAL_REPORTS.FAIL });
        }
    };
};
export const getTotalJobPacks = () => {
    return dispatch => {
        dispatch({ type: GET_JOBPACKS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_JOBPACKS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_packs")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_JOBPACKS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_JOBPACKS.FAIL });
        }
    };
};
export const getReportTitles = () => {
    return dispatch => {
        dispatch({
            type: GET_REPORT_TITLES.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT_TITLES.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/report_titles")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT_TITLES.FAIL
            });
        }
    };
};
export const getTotalUserNames = () => {
    return dispatch => {
        dispatch({ type: GET_USERNAMES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_USERNAMES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/users")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERNAMES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_USERNAMES.FAIL });
        }
    };
};
export const setDateFrom = from => {
    return dispatch => {
        dispatch({ type: SET_DATE_FROM, payload: from });
    };
};
export const setDateTo = to => {
    return dispatch => {
        dispatch({ type: SET_DATE_TO, payload: to });
    };
};

export const setUID = uid => {
    return dispatch => {
        dispatch({ type: SET_UID, payload: uid });
    };
};
export const setReportType = type => {
    return dispatch => {
        dispatch({ type: SET_REPORT_TYPE, payload: type });
    };
};
export const setJobID = type => {
    return dispatch => {
        dispatch({ type: SET_JOB_ID, payload: type });
    };
};
export const setSelectedRow = (rowIndex = null) => {
    return dispatch => {
        dispatch({ type: SET_SELECTED_ROW, payload: rowIndex });
    };
};
export const setWorksheetStatus = (uid, timestamp, status, type) => {
    return dispatch => {
        dispatch({ type: SET_WORKSHEET_STATUS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_WORKSHEET_STATUS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/users/${uid}/reports/${type}/${timestamp}`)
                        .update({ worksheet_status: `${status}` });
                }
            });
        } catch (e) {
            dispatch({ type: SET_WORKSHEET_STATUS.FAIL });
        }
    };
};

export const filterByStatus = status => {
    return dispatch => {
        dispatch({ type: FILTER_WORKSHEET_STATUS, payload: status });
    };
};
